import { RFXTypes } from 'data/BusinessConstants';
import { get as _get } from 'lodash';
import moment from 'moment';

import { RequestPropertyIds } from '../../../data/BackendEntityConstants';
import {
  convertStringToRFIType,
  RFIRequestForm,
  RFIRequestInformation,
  RFIType
} from '../../../interfaces/RFIRequestForm';
import { RFXRequest } from '../../../interfaces/RFXBackendModel';
import { convertStringToRFXRequestState } from '../../../interfaces/RFXRequestForm';
import { getBusinessIdFromBackendModel } from '../../BusinessUtils';
import {
  extractListPropertyOrElseDefault,
  extractNumericalPropertyOrElseDefault,
  extractPropertyOrElseDefault
} from '../../RFXUtils';
import { convertDocuments, convertSuppliers } from '../common/frontendConverter';

/**
 * Converts backend model RFXRequest to frontend model RFIRequestForm
 */
export function convertRFXRequestToRFIRequestForm(rfxRequest: RFXRequest): RFIRequestForm {
  const businessId = getBusinessIdFromBackendModel(rfxRequest);
  const workflow = extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Workflow, businessId);
  const rfiTypeString: string = extractPropertyOrElseDefault(
    rfxRequest.properties,
    RequestPropertyIds.CorrespondenceType,
    RFIType.RFI
  );
  const rfiType = convertStringToRFIType(rfiTypeString);

  const generalInformation: RFIRequestInformation = {
    fullRfxId: rfxRequest.rfxRequestRevisionedId.id.value,
    rfxName: rfxRequest.name,
    rfxType: RFXTypes.RFI,
    rfiType,
    buyer: rfxRequest.buyer.value,
    businessId,
    beginDate: moment(Number(rfxRequest.beginAt)).format('YYYY-MM-DD'),
    beginTime: moment(Number(rfxRequest.beginAt)).format('HH:mm'),
    dueDate: moment(Number(rfxRequest.dueAt)).format('YYYY-MM-DD'),
    dueTime: moment(Number(rfxRequest.dueAt)).format('HH:mm'),
    regions: extractListPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Regions),
    sites: extractListPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Sites),
    categories: extractListPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Categories),
    subCategories: (() => {
      const str = extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.SubCategories, '');
      return str ? str.split(',').filter(sub => sub.trim() !== '') : [];
    })(),
    project: extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Project, ''),
    overview: _get(rfxRequest, 'generalInformation.overview', ''),
    processDetails: _get(rfxRequest, 'generalInformation.processDetail', ''),
    workflow
  };

  return {
    state: convertStringToRFXRequestState(rfxRequest.lifeCycle.lifeCycleState.name),
    rfxRequestVersion: rfxRequest.rfxRequestVersion,
    generalInformation,
    correspondence: {
      subject: extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Subject, ''),
      body: extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Body, ''),
      bodyText: extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.BodyText, '')
    },
    suppliers: convertSuppliers(rfxRequest.suppliers, businessId, workflow),
    'co-managers': {
      coManagerEntries: extractListPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.CoManagers)
    },
    documents: convertDocuments(rfxRequest.documents || []),
    review: {},
    trackingInformation: {
      publishedAt: extractNumericalPropertyOrElseDefault(
        rfxRequest.properties,
        RequestPropertyIds.PublishedAt,
        undefined
      )
    }
  };
}
